import { render, staticRenderFns } from "./addOrUpdate.vue?vue&type=template&id=3347b87e&scoped=true&"
import script from "./addOrUpdate.vue?vue&type=script&lang=js&"
export * from "./addOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3347b87e",
  null
  
)

export default component.exports